import {CHAT_CONFIG} from "../services/ChatConfiguration";

export function agentsMetadataUrl(): string {
    return `${CHAT_CONFIG.API_URL}/agents-metadata`;
}
